"use client";

import { useEffect } from "react";

// Set once any RouteFade has hydrated; client-side only (module state).
let hydrated = false;

/** The section templates' fade (/calculate, /compare, /analyze): the
 *  incoming page fades up on a switch inside the section, never on the
 *  first load. Chrome never counts content first painted at opacity 0
 *  as the Largest Contentful Paint, so a fade on arrival made the
 *  header logo the LCP of every calculator (mobile Lighthouse
 *  /calculate 3.8 s, 2026-10-20). The server and the hydrating render
 *  both leave the class off, so they match; a template that remounts
 *  on a later navigation gets it. */
export default function RouteFade({ children }: { children: React.ReactNode }) {
  const fade = typeof window !== "undefined" && hydrated;
  useEffect(() => {
    hydrated = true;
  }, []);
  return <div className={fade ? "page-enter" : undefined}>{children}</div>;
}
